import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from 'app/components/general/Button';
import EditTeamMemberRow from 'app/components/teamMembers/EditTeamMemberRow';
import Truncate from 'react-truncate';

export default class TeamMemberRow extends React.Component {
  static propTypes = {
    jwtToken: PropTypes.string,
    teamId: PropTypes.string,
    teamMemberId: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    owes: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    updateTeamMember: PropTypes.func.isRequired,
    handleRemove: PropTypes.func,
    handleEdit: PropTypes.func,
    deleteTeamMember: PropTypes.func.isRequired,
    editable: PropTypes.bool,
  };

  static defaultProps = {
    jwtToken: undefined,
    teamId: undefined,
    handleRemove: undefined,
    handleEdit: undefined,
    editable: undefined,
  };

  state = {
    hovered: false,
    editable: this.props.editable || false,
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.editable !== this.props
      && newProps.updatedAt !== this.props.updatedAt
    ) {
      this.setState({ editable: newProps.editable });
    }
  }

  handleMouseEnter = () => {
    this.setState({ hovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ hovered: false });
  };

  toggleEdit = () => {
    this.setState({ editable: true });
  };

  toggleCancel = () => {
    this.setState({ editable: false });
  };

  handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.deleteTeamMember({ id: this.props.teamMemberId });
  };

  render() {
    let editButton = null;
    let deleteButton = null;
    if (this.state.hovered) {
      editButton = (
        <Button
          className="btn-2 btn-thinner"
          onClick={this.toggleEdit}
        >
          Edit
        </Button>
      );

      deleteButton = (
        <Button
          className="btn-2 btn-thinner btn-thin-padding"
          onClick={this.handleDelete}
        >
          Delete
        </Button>
      );
    }

    if (this.state.editable) {
      return (
        <EditTeamMemberRow
          {...this.props}
          cancelTeamMember={this.toggleCancel}
        />
      );
    }
    return (
      <div
        className="row content-row"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.toggleEdit}
      >
        <div className="col col-6 col-sm-3">
          <Truncate>{this.props.fullName}</Truncate>
        </div>
        <div className="col col-2 d-none d-sm-block">
          <Truncate>{this.props.mobile}</Truncate>
        </div>
        <div className="col col-3 d-none d-sm-block">
          <Truncate>{this.props.email}</Truncate>
        </div>
        <div className="col col-6 col-sm-4 btn-flex-group">
          <div className="btn-flex-container thin-margin">
            {editButton}
            {deleteButton}
          </div>
        </div>
      </div>
    );
  }
}
